import { render, staticRenderFns } from "./applyReg.vue?vue&type=template&id=44c919af&scoped=true"
import script from "./applyReg.vue?vue&type=script&lang=js"
export * from "./applyReg.vue?vue&type=script&lang=js"
import style0 from "./applyReg.vue?vue&type=style&index=0&id=44c919af&prod&lang=css"
import style1 from "./applyReg.vue?vue&type=style&index=1&id=44c919af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c919af",
  null
  
)

export default component.exports